var _path, _line, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFloorHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.0005C2.22717 17.317 2.52797 17.5735 2.87642 17.7477C3.22488 17.9219 3.6105 18.0087 4 18.0005C4.3895 18.0087 4.77512 17.9219 5.12358 17.7477C5.47203 17.5735 5.77283 17.317 6 17.0005C6.22717 16.684 6.52797 16.4276 6.87642 16.2534C7.22488 16.0791 7.6105 15.9924 8 16.0005C8.3895 15.9924 8.77512 16.0791 9.12358 16.2534C9.47203 16.4276 9.77283 16.684 10 17.0005C10.2272 17.317 10.528 17.5735 10.8764 17.7477C11.2249 17.9219 11.6105 18.0087 12 18.0005C12.3895 18.0087 12.7751 17.9219 13.1236 17.7477C13.472 17.5735 13.7728 17.317 14 17.0005C14.2272 16.684 14.528 16.4276 14.8764 16.2534C15.2249 16.0791 15.6105 15.9924 16 16.0005C16.3895 15.9924 16.7751 16.0791 17.1236 16.2534C17.472 16.4276 17.7728 16.684 18 17.0005C18.2272 17.317 18.528 17.5735 18.8764 17.7477C19.2249 17.9219 19.6105 18.0087 20 18.0005C20.3895 18.0087 20.7751 17.9219 21.1236 17.7477C21.472 17.5735 21.7728 17.317 22 17.0005",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 13,
    x2: 22,
    y2: 13,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6L7.7396 6.3906C7.29173 7.0624 7.29173 7.9376 7.7396 8.6094L8 9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L11.7396 6.3906C11.2917 7.0624 11.2917 7.9376 11.7396 8.6094L12 9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6L15.7396 6.3906C15.2917 7.0624 15.2917 7.9376 15.7396 8.6094L16 9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorHeating);
export default __webpack_public_path__ + "static/media/FloorHeating.56c4a3f2134f8ee1d1615d3e880a77a7.svg";
export { ForwardRef as ReactComponent };